<template>
  <!-- 이미지 형 -->
  <div>
    <v-hover>
      <v-card class="" :class="`elevation-${hover ? 4 : 0}`"
              slot-scope="{ hover }">
        <template-image></template-image>
        <div class="my-3"></div>
        <template-button></template-button>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import templateImage from './templateFragments/templateImage'
import templateButton from './templateFragments/templateButton'
export default {
  components: {
    templateImage,
    templateButton
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.marketing-push-edit-area {
  box-shadow: 0 0 1px rgba(0,0,0,2);
  padding: 0px 0px 1px 0px;
  border-bottom: 1px;
  border-radius: 0px 0px 10px 10px;
  background: #f4f4f4;
  padding: 0;
  border: 0px
}
</style>



// WEBPACK FOOTER //
// src/components/push/components/pushTemplateImage.vue